type GrecaptchaEnterprise = {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

declare global {
  interface Window {
    grecaptcha?: {
      enterprise?: GrecaptchaEnterprise;
    };
  }
}

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

// The script is injected declaratively via the route's `head.scripts`, so we
// have no load promise to await — poll until `grecaptcha.enterprise` exists,
// then defer to its own `ready` callback for post-load initialisation.
function whenRecaptchaReady(timeoutMs = 10000): Promise<void> {
  return new Promise((resolve, reject) => {
    const deadline = performance.now() + timeoutMs;

    function check() {
      if (window.grecaptcha?.enterprise) {
        window.grecaptcha.enterprise.ready(resolve);
        return;
      }

      if (performance.now() > deadline) {
        reject(new Error("reCAPTCHA failed to load"));
        return;
      }

      window.setTimeout(check, 100);
    }

    check();
  });
}

export async function getRecaptchaToken(action: string): Promise<string> {
  await whenRecaptchaReady();

  return window.grecaptcha!.enterprise!.execute(RECAPTCHA_SITE_KEY, { action });
}
